module.exports = __webpack_public_path__ + "static/media/CNA.3933724a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/CNA.svg
// module id = 228
// module chunks = 0